import { html, LitElement } from 'lit';
import { asyncReplace } from 'lit/directives/async-replace.js';
import { property, state } from 'lit/decorators.js';
import '@digital-realty/ix-icon/ix-icon.js';
import countDownAsync from './countDownAsync.js';

export class IxTimer extends LitElement {
  @property({ type: String }) label = '';

  @property({ type: Number }) duration = 10;

  @property({ attribute: false }) onFinished?: any;

  @state()
  private timer?: AsyncGenerator<number>;

  constructor() {
    super();
    this.onFinished = () => {};
  }

  override connectedCallback() {
    super.connectedCallback();
    this.timer = countDownAsync(this.duration, this.onFinished);
  }

  override render() {
    return html` <div class="timer-container">
      <ix-icon>timer</ix-icon>
      ${this.label} ${this.timer ? asyncReplace(this.timer) : ''}s
    </div>`;
  }
}
